import { BatchProjectGroupsEdit } from 'records/BatchProjectGroupsEdit';
import { ProjectGroup } from 'records/ProjectGroup';
import { ProjectGroupResponse } from 'records/ProjectGroupResponse';
import GQLRequest from 'utils/GQLRequest';

export const getProjectGroups = async (
  projectid: string,
  pagecount: number
): Promise<ProjectGroupResponse> => {
  const { projectGroups } = await new GQLRequest()
    .query(
      `
      query ProjectGroups($projectid: String!, $pagecount: Int!) {
        projectGroups(projectid: $projectid, pagecount: $pagecount) {
          groups {
            projectid
            groupid
            name
            createdby
            createddate
            lastmodifieddate
            members {
              id
              email
              dateadded
              addedbyemail
            }
          }
          cursor
        }
      }
      `
    )
    .variables({ projectid, pagecount })
    .json<{ projectGroups: ProjectGroupResponse }>();

  return projectGroups;
};

export const createProjectGroup = async (
  projectid: string,
  name: string
): Promise<ProjectGroup> => {
  const { createProjectGroup } = await new GQLRequest()
    .query(
      `
      mutation CreateProjectGroup($projectid: String!, $name: String!) {
        createProjectGroup(projectid: $projectid, name: $name) {
          projectid
          groupid
          name
          createdby
          createddate
          lastmodifieddate
          members {
            id
            email
            dateadded
            addedbyemail
          }
        }
      }
      `
    )
    .variables({ projectid, name })
    .json<{ createProjectGroup: ProjectGroup }>();

  return createProjectGroup;
};

export const editProjectGroup = async (
  projectid: string,
  groupid: string,
  name: string
): Promise<ProjectGroup> => {
  const { editProjectGroupName } = await new GQLRequest()
    .query(
      `
      mutation EditProjectGroupName($projectid: String!, $groupid: String!, $name: String!) {
        editProjectGroupName(projectid: $projectid, groupid: $groupid, name: $name) {
          projectid
          groupid
          name
        }
      }
      `
    )
    .variables({ projectid, groupid, name })
    .json<{ editProjectGroupName: ProjectGroup }>();

  return editProjectGroupName;
};

export const deleteProjectGroup = async (
  projectid: string,
  groupid: string
): Promise<boolean> => {
  const { projectDeleted } = await new GQLRequest()
    .query(
      `
      mutation DeleteProjectGroup($projectid: String!, $groupid: String!) {
        deleteProjectGroup(projectid: $projectid, groupid: $groupid)
      }
      `
    )
    .variables({ projectid, groupid })
    .json<{ projectDeleted: boolean }>();

  return projectDeleted;
};

export const addUserToProjectGroup = async (
  projectid: string,
  groupid: string,
  userid: string
): Promise<ProjectGroup> => {
  const { projectGroups } = await new GQLRequest()
    .query(
      `
      mutation AddUserToProjectGroup($projectid: String!, $groupid: String!, $userid: String!) {
        addUserToProjectGroup(projectid: $projectid, groupid: $groupid, userid: $userid) {
          projectid
          groupid
          userid
        }
      }
      `
    )
    .variables({ projectid, groupid, userid })
    .json<{ projectGroups: ProjectGroup }>();

  return projectGroups;
};

export const removeUserFromProjectGroup = async (
  projectid: string,
  groupid: string,
  userid: string
): Promise<ProjectGroup> => {
  const { projectGroups } = await new GQLRequest()
    .query(
      `
      mutation RemoveUserFromProjectGroup($projectid: String!, $groupid: String!, $userid: String!) {
        removeUserFromProjectGroup(projectid: $projectid, groupid: $groupid, userid: $userid) {
          projectid
          groupid
          userid
        }
      }
      `
    )
    .variables({ projectid, groupid, userid })
    .json<{ projectGroups: ProjectGroup }>();

  return projectGroups;
};

export const batchEditProjectGroups = async (
  input: BatchProjectGroupsEdit
): Promise<ProjectGroup[]> => {
  const { batchEditProjectGroups } = await new GQLRequest()
    .query(
      `
      mutation BatchEditProjectGroups($input: BatchProjectGroupsEdit) {
        batchEditProjectGroups(input: $input) {
          projectid
          groupid
          name
          createdby
          createddate
          lastmodifieddate
          members {
            id
            email
            dateadded
            addedbyemail
          }
        }
      }
      `
    )
    .variables({ input })
    .json<{ batchEditProjectGroups: ProjectGroup[] }>();

  return batchEditProjectGroups;
};
